export default {
  id: 245,
  title: 'Target #245 - Knot',
  url: 'https://cssbattle.dev/play/245',
  colors: ['#FFFFFF', '#000000'],
  solution:
    '<p a><p b><p c><style>p[b],p[c]{background:#000}p{position:fixed}p[a]{width:68;height:68;top:38;left:87;border:30px solid;border-radius:50%}p[b]{width:30;height:132;top:98;left:151;border:30px solid #fff;border-width:0 34px}p[c]{width:64;height:30;top:133;left:249',
}
